import parse, {
  DOMNode,
  Element,
  HTMLReactParserOptions,
  domToReact,
} from "html-react-parser";

import { JSX, ReactNode } from "react";

// Transformer to sanitize and customize rendering
const transformer = (domNode: DOMNode, _index: number): JSX.Element | null => {
  if (domNode instanceof Element) {
    const bannedTags = ["script", "style", "iframe"];
    if (bannedTags.includes(domNode.name)) return null;

    if (domNode.name === "a" && domNode.attribs?.href) {
      return (
        <a
          href={domNode.attribs.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {domToReact(domNode.children as DOMNode[])}
        </a>
      );
    }
  }

  return null;
};

// Parser options
const options: HTMLReactParserOptions = {
  replace: transformer,
};
export function parseSafeHtml(html: string): ReactNode {
  return parse(html, options);
}
export const SafeContent = ({ html }: { html: string }) => {
  return <>{parseSafeHtml(html)}</>;
};
